var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.onboarding)?_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"lg":"9","cols":"12","sm":"12"}},[_c('Steps')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }